import ArrowRightBlue from '../../../assets/images/front/svg/arrow-right-blue.svg'
import React, { useState } from 'react'

const faqData = [
  {
    question: 'Co ovlivňuje výslednou cenu doučování?',
    answer:
      'Záleží, zda je doučování online (390 Kč/hod) nebo osobně u vás doma (440 Kč/hod). Cena se může zvýšit při speciálních požadavcích nebo při výuce více dětí najednou.'
  },
  {
    question: 'co se stane, když odešlu objednávku?',
    answer: 'Vybereme vhodného lektora a vše s ním domluvíme. Poté vám zavoláme a doladíme detaily.'
  },
  {
    question: 'co když dítě na doučování nemůže a potřebujeme hodinu zrušit?',
    answer:
      'Stačí napsat lektorovi nebo nám co nejdříve. Zrušená hodina se neplatí, jen při zrušení na poslední chvíli účtujeme 50 % ceny.'
  },
  {
    question: 'kdo jsou vaši lektoři a jak je vybírate?',
    answer:
      'Jsou to hlavně studenti pedagogiky a dalších VŠ, pečlivě vybraní a školení, aby učivo uměli srozumitelně vysvětlit.'
  },
  {
    question: 'kde doučování probíha?',
    answer:
      'Nejčastěji u vás doma. Pokud to nejde, můžeme se sejít v knihovně nebo jiné domluvené lokalitě. Doučování může probíhat také on-line.'
  },
  {
    question: 'můžou se učit dvě a víe dětí najednou? má to vliv na cenu za hodinu?',
    answer: 'Ano, pokud probírají stejnou látku a mají podobné tempo. Cena začíná na 600 Kč/hod.'
  },
  {
    question: 'jsme s lektorem nespokojeni. můžete nám ho vyměnit?',
    answer: 'Ano, dejte nám vědět a co nejrychleji vám zajistíme náhradu.'
  }
]

const FAQAccordion: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const handleToggle = (idx: number) => {
    setOpenIndex((prev) => (prev === idx ? null : idx))
  }

  return (
    <div className="max-w-[720px] mx-auto px-4">
      <div className="grid grid-cols-12 gap-2 mx-auto">
        {faqData.map((item, idx) => (
          <div className="col-span-12" key={item.question}>
            <button
              type="button"
              className="flex flex-col items-center bg-white rounded-lg px-4 py-2 w-full text-left outline-none cursor-pointer hover:bg-[rgba(255,255,255,0.85)] transition-all duration-300 js-accordion"
              onClick={() => handleToggle(idx)}
              aria-expanded={openIndex === idx}
            >
              <div className="flex items-center w-full text-[#0183BA] md:text-xl">
                <img
                  src={ArrowRightBlue}
                  alt=""
                  width="8"
                  height="8"
                  className={`me-1 accordion-arrow-right transition-transform duration-300${
                    openIndex === idx ? ' rotate-90' : ''
                  }`}
                />
                <span>{item.question}</span>
              </div>
              <p
                className={`js-accordion-text w-full mt-1 ps-4 transition-all duration-300${
                  openIndex === idx ? '' : ' hidden'
                }`}
              >
                {item.answer}
              </p>
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FAQAccordion
